import type { SVGProps } from 'react';

// A handful of hand-drawn 16px icons, 1.5px stroke, used only where a word would be clumsy.
const paths = {
  check: 'M3.5 8.5l3 3 6-7',
  plus: 'M8 3v10M3 8h10',
  close: 'M4 4l8 8M12 4l-8 8',
  left: 'M10 3.5L5.5 8 10 12.5',
  right: 'M6 3.5L10.5 8 6 12.5',
  trash: 'M3 4.5h10M6.5 4.5V3h3v1.5M4.5 4.5l.6 8.5h5.8l.6-8.5',
  play: 'M5.5 3.5v9l7-4.5z',
  pause: 'M5.5 3.5v9M10.5 3.5v9',
  stop: 'M4.5 4.5h7v7h-7z',
  arrowUp: 'M8 13V3M4 7l4-4 4 4',
  arrowDown: 'M8 3v10M4 9l4 4 4-4',
  copy: 'M5.5 5.5h7v7h-7zM3.5 10.5v-7h7',
  dots: 'M3.5 8h.01M8 8h.01M12.5 8h.01',
  pencil: 'M10.5 3.5l2 2-7 7h-2v-2z',
  text: 'M3 4.5h10M3 8h10M3 11.5h6',
  checklist: 'M3.5 3.5h9v9h-9zM6 8l1.5 1.5 3-3',
  comment: 'M3 3.5h10v7H7.5L5 13v-2.5H3z',
  clock: 'M8 2.75a5.25 5.25 0 1 0 0 10.5 5.25 5.25 0 0 0 0-10.5zM8 5.25V8l1.75 1.25',
  archive: 'M2.75 3.5h10.5v3H2.75zM3.75 6.5v6h8.5v-6M6.5 9h3',
  tag: 'M2.75 2.75h5l5.5 5.5-5 5-5.5-5.5zM5.5 5.5h.01',
  cover: 'M2.75 3.25h10.5v9.5H2.75zM2.75 6.5h10.5',
  link: 'M6.5 9.5l3-3M7 4.5l1-1a2.83 2.83 0 0 1 4 4l-1 1M9 11.5l-1 1a2.83 2.83 0 0 1-4-4l1-1',
  move: 'M3 8h9.5M9 4.5L12.5 8 9 11.5',
  board: 'M2.75 3h3v10h-3zM6.5 3h3v7h-3zM10.25 3h3v5h-3z',
  target:
    'M8 2.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11zM8 5.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5zM8 8h.01',
  repeat:
    'M3.25 7.5a4.75 4.75 0 0 1 8.4-3M12.25 2v2.75H9.5M12.75 8.5a4.75 4.75 0 0 1-8.4 3M3.75 14v-2.75H6.5',
  calendar: 'M2.75 4h10.5v9H2.75zM2.75 7h10.5M5.5 2.5v3M10.5 2.5v3',
} as const;

export type IconName = keyof typeof paths;

export function Icon({ name, ...props }: { name: IconName } & SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      <path d={paths[name]} />
    </svg>
  );
}
